module.exports = __webpack_public_path__ + "img/toyota.41db345c.svg";